var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"tw-w-full tw-min-h-full c-bg-gray"},[_c('r-f-q-nav'),_c('div',{staticClass:"tw-flex tw-min-h-screen"},[_c('div',{staticClass:"tw-container tw-mx-auto"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }